import React, { Fragment } from 'react'

const FullStack = () => {
    return (
        <Fragment>
            <h2>Full Stack Solutions</h2>
            <p>
                Having a development team that is skilled at full-stack
                solutions gives you the peace of mind that your application can
                hit all aspects of creating a business portal for your customers
                to enjoy for years to come.
            </p>
        </Fragment>
    )
}

export default FullStack
